import LottieComponent from './LottieComponent';

export default LottieComponent;
